import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { ListingCostsShape } from '../../constants/shapes';

import DoubleArrowIcon from './DoubleArrowIcon';

import styles from './PaymentTimeline.module.scss';
import OnBookingClosed from './OnBookingClosed';
import OnCheckIn from './OnCheckIn';
import DuringStay from './DuringStay';
import OnCheckOut from './OnCheckOut';
import Extra from './Extra';

const noop = () => {};
const PaymentTimeline = ({
  offers = [],
  listingCosts = {},
  pricing = {},
  listingMonthlyPrice = null,
  downPaymentTimeInterval,
  hasNoDeposit,
  onSelectDates = noop,
  unCollapseAll = false,
  isInstantBooking = false,
  currencyIsoCode,
  hideDepositElanLaw = false
}) => {
  const completedMarkerClasses = classNames(
    styles['payment-timeline__marker'],
    styles['payment-timeline__marker--completed']
  );

  const progressLineClasses = classNames(
    styles['payment-timeline__progress-line'],
    styles['payment-timeline__progress-line--completed']
  );

  const isPricingCalculated = pricing?.totalContractValue > 0;

  return (
    <div className={styles['payment-timeline']}>
      <section className={styles['payment-timeline__section']}>
        <div className={completedMarkerClasses}>
          <DoubleArrowIcon />
        </div>
        <div className={progressLineClasses}>
          <span />
        </div>
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {isInstantBooking
              ? trans('payment.timeline.section1.title.instant-booking')
              : trans('payment.timeline.section1.title')}
          </h3>
          <OnBookingClosed
            isPricingCalculated={isPricingCalculated}
            currencyCode={currencyIsoCode}
            pricing={pricing}
            costs={listingCosts?.onBookingClosed}
            downPaymentTimeInterval={downPaymentTimeInterval}
            onSelectDates={onSelectDates}
            collapsible={unCollapseAll}
            isCollapsed={!unCollapseAll}
          />
        </div>
      </section>
      <section className={styles['payment-timeline__section']}>
        <div className={styles['payment-timeline__marker']} />
        <div className={styles['payment-timeline__progress-line']} />
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section2.title')}
          </h3>

          <div className={styles['payment-timeline__cards']}>
            <OnCheckIn
              isPricingCalculated={isPricingCalculated}
              costs={listingCosts?.onCheckIn}
              currencyCode={currencyIsoCode}
              hasNoDeposit={hasNoDeposit}
              isCollapsed={!unCollapseAll}
              onSelectDates={onSelectDates}
              hideDepositElanLaw={hideDepositElanLaw}
            />

            <DuringStay
              offers={offers}
              appliedOfferValue={pricing?.offer?.discountValue}
              listingMonthlyPrice={listingMonthlyPrice}
              isPricingCalculated={isPricingCalculated}
              costs={listingCosts?.duringStay}
              currencyCode={currencyIsoCode}
              isCollapsed={!unCollapseAll}
              contractDurationType={pricing?.contractDurationType}
            />

            <OnCheckOut
              isPricingCalculated={isPricingCalculated}
              costs={listingCosts?.onCheckOut}
              currencyCode={currencyIsoCode}
              isCollapsed={!unCollapseAll}
              onSelectDates={onSelectDates}
            />

            <Extra costs={listingCosts?.extra} currencyCode={currencyIsoCode} />
          </div>
        </div>
      </section>
    </div>
  );
};

PaymentTimeline.propTypes = {
  pricing: PropTypes.shape({
    currencyCode: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    totalContractValue: PropTypes.number
  }),
  offers: PropTypes.arrayOf(PropTypes.shape({})),
  listingCosts: ListingCostsShape,
  listingMonthlyPrice: PropTypes.string,
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }).isRequired,
  hasNoDeposit: PropTypes.bool.isRequired,
  onSelectDates: PropTypes.func,
  unCollapseAll: PropTypes.bool,
  isInstantBooking: PropTypes.bool,
  currencyIsoCode: PropTypes.string.isRequired,
  hideDepositElanLaw: PropTypes.bool
};

export default PaymentTimeline;
